export default __webpack_public_path__ + "static/media/mad-ape-012.49c60b3a.svg";